// the STEPS enums are used to determine the order of the steps in the service modal
export enum STEPS {
  SELECT_CUSTOMER = 1,
  CUSTOMER_ITEM = 2,
  WORK_DESCRIPTION = 3,
  SCHEDULE = 4,
}

export enum CUSTOMER_STEP_VIEW {
  SELECT_CUSTOMER = 1,
  ADD_NEW_CUSTOMER = 2,
}

export enum SCHEDULE_INPUT_BOX_TYPE {
  HOURS = 'Hours',
  MINUTES = 'Minutes',
}
